import {Injectable} from "@angular/core";
import {LoginPassword} from "../../core/auth/login-password";
import {Observable} from "rxjs/Observable";
import {LoginResponse} from "./login-response";

@Injectable()
export abstract class LoginService {
  abstract signIn(loginPassword: LoginPassword): Observable<LoginResponse>;
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/login/login.service.ts